import React, { createContext, useContext, useState, useEffect } from 'react'
import { adminAPI } from '../services/api'

const AuthContext = createContext()

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null)
  const [loading, setLoading] = useState(true)
  const [authChecked, setAuthChecked] = useState(false)

  useEffect(() => {
    const token = localStorage.getItem('adminToken')
    if (token && !authChecked) {
      // Перевіряємо чи токен валідний, отримуючи статистику
      checkAuth()
    } else if (!token) {
      setLoading(false)
    }
  }, [authChecked])

  const checkAuth = async () => {
    if (authChecked) return
    
    try {
      const response = await adminAPI.getStats()
      if (response.data.success) {
        // Якщо статистика завантажилась, значить токен валідний
        // Отримуємо дані адміна з токена (в реальному проекті можна додати окремий ендпоінт)
        const adminData = {
          id: 1,
          email: 'admin@euromix.com',
          fullName: 'Адміністратор'
        }
        setAdmin(adminData)
      }
    } catch (error) {
      console.error('Auth check error:', error)
      logout()
    } finally {
      setLoading(false)
      setAuthChecked(true)
    }
  }

  const login = async (email, password) => {
    try {
      const response = await adminAPI.login(email, password)
      if (response.data.success) {
        const { token, admin: adminData } = response.data
        localStorage.setItem('adminToken', token)
        setAdmin(adminData)
        return { success: true }
      }
    } catch (error) {
      return { 
        success: false, 
        message: error.response?.data?.message || 'Помилка авторизації' 
      }
    }
  }

  const logout = () => {
    localStorage.removeItem('adminToken')
    setAdmin(null)
    setAuthChecked(false)
  }

  const value = {
    admin,
    login,
    logout,
    loading
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}
